<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：商品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商户名称">
          <el-input class="max-w460" v-model="searchForm.name"></el-input>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="shopSupplierId" align="center" label="商户id"></el-table-column>
          <el-table-column prop="name" label="名称" align="center"></el-table-column>
          <el-table-column prop="product_sales" align="center" label="商品总销量"></el-table-column>
          <el-table-column prop="order_count" align="center" label="订单数量"></el-table-column>
          <el-table-column prop="order_money" align="center" label="订单金额">
            <template slot-scope="scope">
              <span style="color:red">￥ {{ scope.row.order_money }} 元</span>
            </template>
          </el-table-column>
          <el-table-column prop="isClock_count" align="center" label="加钟数量"></el-table-column>
          <el-table-column prop="isClock_count_rate" align="center" label="加钟率"></el-table-column>
          <el-table-column prop="waiter_count" align="center" label="技师数量">
            <template slot-scope="scope">
              <span style=""> {{ scope.row.waiter_count }} 人</span>
            </template>
          </el-table-column>
          <el-table-column prop="user_count" align="center" label="下单用户数量"></el-table-column>
          <el-table-column prop="waiter_minute" align="center" label="技师在线时长">
            <template slot-scope="scope">
              <span style="color:#1cc53b"> {{ scope.row.waiter_minute }} 分钟</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="total_money" label="总货款"></el-table-column> -->
          <el-table-column prop="money" align="center" label="当前可提现金额">
            <template slot-scope="scope">
              <span style="color:red">￥ {{ scope.row.money }} 元</span>
            </template>
          </el-table-column>
          <el-table-column prop="freeze_money" align="center" label="已冻结金额">
            <template slot-scope="scope">
              <span v-if="scope.row.freeze_money>0" style="color:orange">￥ {{ scope.row.freeze_money }} 元</span>
              <span v-else>￥ {{ scope.row.freeze_money }} 元</span>
            </template>
          </el-table-column>
          <el-table-column prop="cash_money" align="center" label="累积提现佣金"></el-table-column>
          <el-table-column prop="status" align="center" label="店铺状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==0">正常</el-tag>
              <el-tag v-else type="danger">不正常</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="store_type" align="center" label="店铺类型">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.store_type==10">普通</el-tag>
              <el-tag v-else type="success">自营</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="deposit_money" label="保证金"></el-table-column> -->
          <!-- <el-table-column prop="score" label="评分"></el-table-column> -->
          <!-- <el-table-column prop="server_score" label="服务评分"></el-table-column> -->
          <!-- <el-table-column prop="describe_score" label="描述评分"></el-table-column>
          <el-table-column prop="fav_count" label="关注人数"></el-table-column>-->

          <!-- <el-table-column prop="logo" label="店铺logo">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.logo" alt="" /></div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>
          <el-table-column prop="update_time" align="center" label="更新时间"></el-table-column>
        </el-table>
      </div>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import StatisticsApi from "@/api/statistics.js";
export default {
  components: {},
  data() {
    return {
      /*切换菜单*/
      activeName: "",
      /*切换选中值*/
      activeIndex: "0",
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        createTime: "",
        name: ""
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryModel: {
        waiter_user_id: ""
      },

      serviceList: [],
      supplierList: [],
      /*商品统计*/
      product_count: {},
      open_edit: false
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    onExport: function() {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      StatisticsApi.getSupplierList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*打开编辑*/
    editClick(row) {
      this.categoryModel.waiter_user_id = row.waiter_user_id;
      this.open_edit = true;
      // this.$router.push({
      //   path: "/technician/online/onlinedetail",
      //   query: {
      //     waiter_user_id: row.waiter_user_id,
      //     scene: "edit"
      //   }
      // });
    },

    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          StatisticsApi.delProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>
<style lang="scss">
.product-list {
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-right: 15px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 9px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }
}
</style>
<style lang="scss">
.product-list {
  /* switch按钮样式 */
  .switchs .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switchs .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switchs .el-switch__label--right span {
    margin-right: 15px;
  }
  /*关闭时文字位置设置*/
  .switchs .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switchs .el-switch__label--left span {
    margin-left: 9px;
  }
  /*显示文字*/
  .switchs .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switchs.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/statistics/individualsupplier/index.vue